export default __webpack_public_path__ + "static/media/logo-dubidoc.ee93bb09.svg";